/**
 * @file 点赞按钮
 * @author wangzhuang
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './index.less';

export default class LikeBtn extends Component {

    static propTypes = {
        hasLike: PropTypes.bool,
        handleClick: PropTypes.func,
        num: PropTypes.number
    };

    constructor(props, context) {
        super(props, context);
        this.likeBtnClick = this.likeBtnClick.bind(this);
    }

    likeBtnClick() {
        const hasLike = this.props.hasLike;
        if (!hasLike) {
            this.props.handleClick();
        }
    }

    render() {
        const {
            hasLike,
            num
        } = this.props;

        let btnClass = classNames({
            'like-btn': true,
            'on': hasLike
        });

        return (
            <div
                className={btnClass}
                onClick={this.likeBtnClick}>{num}</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LikeBtn/index.js